const formatBytes = (bytes: any, decimals = 2) => {
  if (!+bytes) return '0 Bytes'

  const byteVal = 1024
  const decimalPlaces = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(byteVal))

  return `${parseFloat((bytes / Math.pow(byteVal, i)).toFixed(decimalPlaces))} ${sizes[i]}`
}

export default formatBytes
